import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service'

@Injectable()
export class AuthGuardAdmin implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
        console.debug('AuthGuardAdmin: instantiated');
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.isAuthenticated()) {
            console.debug('canActivate: not authenticated');

            this.router.navigate(['/admin/pgs/login'], { queryParams: { returnUrl: state.url }});

            return false;
        }

        return true;
    }

    private isAuthenticated(): boolean {
        if (!this.authService.appUser || !this.authService.appUser.userDetail || !this.authService.appUser.userDetail.roles) {
            return false;
        }

        return this.authService.appUser.userDetail.roles.admin;
    }
}
